/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECompanyFilterType } from "../types/ECompanyFilterType.ts";

/**
 * @description 1 = Main | 2 = Company | 3 = All |
 */
export const eCompanyFilterTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Main | 2 = Company | 3 = All | ",
  ) as unknown as ToZod<ECompanyFilterType>;
